import { render, staticRenderFns } from "./ConfigAutorizaciones.vue?vue&type=template&id=63076006&"
import script from "./ConfigAutorizaciones.vue?vue&type=script&lang=ts&"
export * from "./ConfigAutorizaciones.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigAutorizaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports